import { SpinBoundaryStartActionHandler } from "@slot/client-engine";
import type { ReplayPlugin } from "@slot/client-engine";
import type { GameFeature } from "@slot/game-shell";
import { SecretBonusPresenter } from "./SecretBonusPresenter";
import { PresentSecretBonusActionHandler } from "./replay/PresentSecretBonusActionHandler";

/**
 * The Secret Bonus (decision 51): a `SecretBonusPresenter` driven by `present_secret_bonus` (the symbol on the last
 * board, the offer it opens) and by every spin's boundary (the offer goes with the board).
 */
export const secretBonusFeature: GameFeature<ConstructorParameters<typeof SecretBonusPresenter>[0], SecretBonusPresenter, SecretBonusPresenter> = {
  createPresenter: (deps) => new SecretBonusPresenter(deps),

  createPlugin(target): ReplayPlugin {
    return {
      name: "secret-bonus",
      actionHandlers: [new SpinBoundaryStartActionHandler(async () => target.clear()), new PresentSecretBonusActionHandler(target)],
    };
  },
};
